import React from 'react';
import { Box, SxProps, Theme } from '@mui/material';
import AppOutlineButton from './AppOutlineButton';

/**
 * AppFilterGrid — grille responsive des champs d'un composant `XxxFilters`.
 *
 * Grille CSS `auto-fill` : le nombre de colonnes s'adapte seul à la largeur
 * disponible (pas de points de rupture à calculer), et **chaque enfant direct est
 * une case**. Un filtre conditionnel qui rend `null` ne crée donc AUCUNE case vide
 * — à condition de ne PAS l'envelopper dans un conteneur :
 *
 *   ✅ {isAllMode && <SelectDepartement … />}
 *   ❌ <Box>{isAllMode && <SelectDepartement … />}</Box>   → case vide
 *
 * Les champs doivent être en `size="small"` pour garder une hauteur homogène.
 */
const AppFilterGrid: React.FC<{
  children: React.ReactNode;
  /** Largeur minimale d'une case (px). Déf. 200. */
  minItemWidth?: number;
  sx?: SxProps<Theme>;
}> = ({ children, minItemWidth = 200, sx }) => (
  <Box
    sx={[
      {
        display: 'grid',
        gridTemplateColumns: `repeat(auto-fill, minmax(min(100%, ${minItemWidth}px), 1fr))`,
        gap: 2,
        alignItems: 'center',
        p: 2,
      },
      ...(Array.isArray(sx) ? sx : sx ? [sx] : []),
    ]}
  >
    {children}
  </Box>
);

/** Bouton « Réinitialiser » standard d'un filtre, aligné sur la hauteur des champs `small`. */
export const AppFilterResetButton: React.FC<{ onClick: () => void; label?: string }> = ({
  onClick,
  label = 'Réinitialiser',
}) => (
  <AppOutlineButton fullWidth onClick={onClick} sx={{ height: 40 }}>
    {label}
  </AppOutlineButton>
);

export default AppFilterGrid;
